<template>
    <div class="trz_leave_settings">
        
        <template>
            <div class="row mt-4">
                <div class="col-sm-8">
                    <div class="card ">
                        <div class="card-header">
                            Remaining Leaves:
                        </div>
                        <div class="card-body">
                         
                            
                                
                                <div v-for="leave_type in leavetypes">
                                    {{leave_type.leave_type_title}} - {{leave_limit[leave_type.leave_type_id]}} days.
                                </div>

                            
                        </div>
                    </div>
                </div>

                <div class="col-sm-4">
                    <div class="card ">
                        <div class="card-header">
                            List of Leave Applications
                        </div>
                        <div class="card-body " style="height:300px; overflow-y:scroll;">
                            <div v-if="leaves.length == 0">
                                No applied leave found.
                            </div>
                            <div v-else>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item" v-for="leave in leaves" :key="leave.leave_date">
                                        <div class="cursor-pointer" :title="leave.type + ' - ' + leave.comment" v-b-tooltip placement="right"  @click="updateLeave(leave.id)">                                        
                                            {{formatdate(leave.leave_date)}} - {{leave.status}}
                                        </div>

                                    </li>
                                </ul>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <b-modal id="bv-modal-leave"  hide-footer v-bind:title="leave_details.leave_date">
                    <b-form @submit.stop.prevent="onSubmitLeaveUpdate">
                        <input type="hidden" v-model="leave_details.id" name="id">
                        
                        <b-form-group id="status-group" label="Status" label-for="status">
                            <b-form-select id="status" name="status" v-model="leave_details.flg_status" v-validate="{ required: true }" :options="leavestatus"></b-form-select>
                            
                        </b-form-group>

                        <b-button type="submit" variant="primary">Submit</b-button> 

                    </b-form>
                </b-modal>
            </div>
        </template>
    </div>
</template>
<script>    
    
    import moment from 'moment'

    export default{
        
        mounted() {
            
        },
        props: [],   
        components: {
            
        },     
        data(){
            
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 15th two months prior
            const minDate = new Date(today)
            minDate.setMonth(minDate.getMonth())
            minDate.setDate(minDate.getDate() + 1)
            /*const maxDate = new Date(today)
            maxDate.setMonth(maxDate.getMonth() + 2)
            maxDate.setDate(15)*/
            const startdate = minDate

            return {
                min: minDate,
                //max: maxDate,
                day_one:startdate , day_two:startdate,
                fdata : {day_one:startdate , day_two:startdate, days:null , leave_type_id:null , comment:null},
                leave_details : {},
                company_id : 0 ,

                holidays : [],
                leaves : [],
                holidays_date_arr : [],
                leave_limit : [],
                disable_flg : false,
                
                week_holidays : [6],
                all_week_holidays : [6],
                week_start_day : 7,
                count_options: [
                            { value: 1, text: '1' },
                            { value: 2, text: '2' },
                            { value: 3, text: '3' },
                            { value: 4, text: '4' },
                            { value: 5, text: '5' },
                            { value: 6, text: '6' },
                            { value: 7, text: '7' },
                            { value: 8, text: '8' },
                            { value: 9, text: '9' },
                        ],

                
                options: [
                    { text: 'Friday', value: '5' },
                    { text: 'Saturday', value: '6' },
                    { text: 'Sunday', value: '0' },
                    { text: 'Monday', value: '1' },
                    { text: 'Tuesday', value: '2' },
                    { text: 'Wednesday', value: '3' },
                    { text: 'Thursday', value: '4' }
                ],
                //1 for casual leave, 2 for sick leave, 3 for annual leave, 4 for unpaid leave, 5 for compaensatory leave 
                leavetypes: [],
                
                leavestatus: [
                    { text: 'Applied', value: '0' },
                    { text: 'Approved', value: '1' },
                    { text: 'Refused', value: '2' },
                ],       
                
            }
        },
        methods:{

            dateDisabled(ymd, date) {
                const x = moment(String(date)).format('YYYY-MM-DD');
                const weekday = date.getDay();
                const day = date.getDate();                
                return this.all_week_holidays.includes(weekday) || this.holidays_date_arr.includes(x);
            },
            updateToDate:function()
            {
                this.day_two = this.day_one;
            },            
            formatdate:function(x) 
            {
                return moment(x).format('Do MMMM YYYY');
            },
            checkGaterDate(x)
            {
                return moment(x).isAfter(moment(new Date()).format('YYYY-MM-DD'));
            },
            getEmployeeLeaveSettings:function() 
            {   
                
                axios.get(this.$api_url+'/employee/leave/settings' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    
                    if(response.data.length != 0)
                    {
                        console.log( response.data);
                        this.company_id =  response.data.company_id;
                        this.all_week_holidays = response.data.week_holidays;
                        this.week_holidays = response.data.week_holidays.split(',');
                        this.week_start_day =  response.data.week_start_day;

                        
                    }       
                    
                }.bind(this));

            },
            getLeaveTypeByLeavePolicy: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                axios.get(this.$api_url+'/leave/type/by/leave/policy' , {
                    params: {
                        
                    }
                }).then(function(response){
                    
                    this.leavetypes = response.data;
                    
                }.bind(this));
            }, 
            updateLeave : function(x)
            {
                //leave_details
                axios.get(this.$api_url+'/employee/leave/details?id='+x , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    //console.log(response.data);
                    
                    this.leave_details = response.data;    
                    
                }.bind(this));
                this.$bvModal.show('bv-modal-leave');
            }, 
            onSubmitLeaveUpdate : function()
            {
                let currentObj = this;
                let formData = new FormData();
                for (let [key, value] of Object.entries(this.leave_details)) 
                {                    
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);                    
                    
                } 
                axios.post(this.$api_url+'/employee/leave/details', formData,)
                            .then(function (response) 
                            {                             
                                this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });  

                                this.getLeaves(); 
                                this.$bvModal.hide('bv-modal-leave');
                                this.$emit('childToParent');        
                                
                            }.bind(this))
                            .catch(function (error) 
                            {                                    
                                currentObj.serverError(error);
                            });
            },        
            getHoliDays:function() 
            {   
                axios.get(this.$api_url+'/company/holidays' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    
                    if(response.data.length != 0)
                    {
                        //console.log( response.data);                        
                        this.holidays = response.data.holidays;
                        this.holidays_date_arr = response.data.holidays_date_arr.split(',').map(function(item){ return item;});
                    }       
                    
                }.bind(this));

            },
            getLeaves:function() 
            {   
                
                axios.get(this.$api_url+'/employee/leaves' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    
                    if(response.data.length != 0)
                    {
                        //console.log( response.data);
                        this.leaves = response.data.leave_data;
                        this.leave_limit = response.data.limit;
                    }       
                    
                }.bind(this));

            },
            saveLeave:function()
            {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    let currentObj = this;
                    let formData = new FormData();
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 

                    
                    axios.post(this.$api_url+'/employee/leaves', formData,)
                                .then(function (response) 
                                {                             
                                    if(response.data.status)
                                    {
                                        
                                        //this.leaves = response.data.leave_data;
                                        //this.leave_limit = response.data.limit;
                                        this.getLeaves();


                                        this.$bvToast.toast('Saved!', {
                                                title: `Success`,
                                                variant: 'success',
                                                solid: true
                                            }); 
                                    }
                                    else
                                    {
                                        this.$bvToast.toast(response.data.message, {
                                                title: `Warning`,
                                                variant: 'warning',
                                                solid: true
                                            }); 
                                    }
                                    
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {                                    
                                    currentObj.serverError(error);
                                });
            
                });
            },            
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            fetchDateDisabled()
            {                
                return this.week_holidays;
            }
        },
        created: function(){
            this.getEmployeeLeaveSettings();
            this.getLeaveTypeByLeavePolicy();
            this.getHoliDays();
            this.getLeaves();
        },
        computed: 
        {
            dateDiff()
            {
                //fdata : {day_one:null , day_two:null, days:null , details:null},
                this.disable_flg = false;
                
                var day_one = moment(this.day_one);
                var day_two = moment(this.day_two);  

                let days = 0;

                this.fdata.day_one = moment(String(this.day_one)).format('YYYY-MM-DD');
                this.fdata.day_two = moment(String(this.day_two)).format('YYYY-MM-DD');

                if(this.day_one === this.day_two)
                {
                    this.fdata.days = 1;
                    //return 1;
                    days = 1;
                }
                else
                {
                    days = day_two.diff(day_one, 'days') // 1

                    ++days;
                }
                

                
                if(days > 0)
                {
                    
                    this.fdata.days = days;

                    if(days > this.leave_limit[this.fdata.leave_type_id])
                    {
                        this.disable_flg = true;

                        return 'Limit Exceed!';
                    }
                    else
                    {
                        this.disable_flg = false;
                        return days;
                    }
                    
                }                   
                else if(days < 0)
                {
                    this.fdata.days = 0;
                    this.disable_flg = true;
                    return 'Invalid Date Range';
                }                
                    
            },
            fetchStartWeekday()
            {
                return this.week_start_day;
            },
            
        }
    }
</script>
<style >
    .trz_leave_settings .custom-select{width: auto !important;}
    .trz_list li{margin-top:5px;}
</style>